import { Action, ACTION_TYPE } from '@abiglobalhealth/go-types'
import * as Sentry from '@sentry/browser'

import { actionsRequest } from './utils'

export const handleSession = async <T extends Action<ACTION_TYPE.HANDLE_SESSION>>(payload: T['payload']): Promise<T['response']> => {
  const { data } = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.HANDLE_SESSION
  })

  Sentry.setTags({
    sessionId: data.session?.id
  })

  return data
}
